$(document).ready(function () {

  $(document).on('click', '.tvproduct-list-menu-btn', function () {
    if ($('.tvproduct-list-menu-btn').hasClass('active')) {
      $('.tvproduct-list-menu-btn').removeClass('active');
    } else {
      $('.tvproduct-list-menu-btn').addClass('active');
    }
  });

  $("body").click(function () {
    $('.owl-dot').attr("aria-label", "Dot");
    $('.slick-track').attr("aria-label", "Slick Slider");
  });

  // $('#column-left, #content-wrapper, #column-right').theiaStickySidebar({
  //   additionalMarginTop: 70
  // });

  // $('.tvproduct-5 .product__media-wrapper, .tvproduct-5 .product__info-wrapper, .tvproduct-6 .product__media-wrapper, .tvproduct-6 .product__info-wrapper').theiaStickySidebar({
  //   additionalMarginTop: 70
  // });

  // $('.template-index #column-left, .template-index #content-wrapper').theiaStickySidebar({
  //   additionalMarginTop: 70
  // });

  // $('.template-list-collections #column-left, .template-list-collections #content-wrapper').theiaStickySidebar({
  //   additionalMarginTop: 70
  // });

  // $('.template-collection #column-left, .template-collection #content-wrapper').theiaStickySidebar({
  //   additionalMarginTop: 70
  // });

  $('.featured-product .product-vertical .slick-slider').slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    prevArrow: $('.tvvertical-slider-pre'),
    nextArrow: $('.tvvertical-slider-next'),
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: false,
    height: true,
    centerMode: false,
    vertical: true,
    focusOnSelect: true,
    autoplay: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          adaptiveHeight: false,
          dots: true,
          prevArrow: '',
          nextArrow: ''
        }
      }
    ]
  });

  // Main Product 1 Slider

  $('.main-product.tvproduct-1 .product-vertical .slick-slider').slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 1000,
    prevArrow: $('.tvvertical-slider-pre'),
    nextArrow: $('.tvvertical-slider-next'),
    slidesToShow: 5,
    slidesToScroll: 1,
    variableWidth: false,
    height: true,
    centerMode: false,
    focusOnSelect: true,
    autoplay: true,
    adaptiveHeight: true,
    vertical: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          adaptiveHeight: false,
          dots: true,
          prevArrow: '',
          nextArrow: '',
        }
      }
    ]
  });

  // Main Product 2 Slider

  $('.main-product.tvproduct-2 .product-vertical .slick-slider').slick({
    arrows: false,
    dots: true,
    infinite: true,
    speed: 1000,
    prevArrow: $('.tvvertical-slider-pre'),
    nextArrow: $('.tvvertical-slider-next'),
    slidesToShow: 5,
    slidesToScroll: 1,
    variableWidth: false,
    height: true,
    centerMode: false,
    focusOnSelect: true,
    autoplay: true,
    adaptiveHeight: false,
    vertical: false,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          adaptiveHeight: false,
          dots: true,
          prevArrow: '',
          nextArrow: '',
        }
      }
    ]
  });

  // Main Product 3 Slider

  $('.main-product.tvproduct-3 .product-vertical .slick-slider').slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 1000,
    prevArrow: $('.tvvertical-slider-pre'),
    nextArrow: $('.tvvertical-slider-next'),
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: false,
    height: true,
    centerMode: false,
    focusOnSelect: true,
    autoplay: true,
    adaptiveHeight: false,
    vertical: false,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          adaptiveHeight: false,
          dots: true,
          prevArrow: '',
          nextArrow: '',
        }
      }
    ]
  });

  // Main Product 4 Slider

  $('.main-product.tvproduct-4 .product-vertical .slick-slider').slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 1000,
    prevArrow: $('.tvvertical-slider-pre'),
    nextArrow: $('.tvvertical-slider-next'),
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: false,
    height: true,
    centerMode: true,
    focusOnSelect: true,
    autoplay: true,
    adaptiveHeight: false,
    vertical: false,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          adaptiveHeight: false,
          dots: true,
          prevArrow: '',
          nextArrow: '',
        }
      }
    ]
  });

  $('body').on('mouseenter', '.thumbnail-list__item', function (e) {
    e.preventDefault();
    $('.thumbnail-list__item').removeClass('is_active');
    $(this).addClass('is_active');
  });

  $('.tvproduct-wrapper.grid .tvproduct-variant').balance();

  $('.tvcmsproduct-grid-list .tvproduct-grid').addClass('active');
  function removeClassesOfView() {
    $('#products').removeClass('grid grid-2 list list-2 catelog');
  }
  $(document).on('click', '.tvcmsproduct-grid-list .tvproduct-grid', function () {
    removeClassesOfView();
    $('#products').addClass('grid');
    // $('.tvgrid-list-view-product .tvproduct-wrapper.grid').balance();
    $('.tvcmsproduct-grid-list .tvproduct-grid-2').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-list').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-list-2').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-catalog').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-grid').addClass('active');
  });
  // End Grid View
  // Start Grid-2 View
  $(document).on('click', '.tvcmsproduct-grid-list .tvproduct-grid-2', function () {
    removeClassesOfView();
    $('#products').addClass('grid-2');
    // $('.tvgrid-list-view-product .tvproduct-wrapper.grid-2').balance();
    $('.tvcmsproduct-grid-list .tvproduct-grid').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-list').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-list-2').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-catalog').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-grid-2').addClass('active');
  });
  // End Grid-2 View
  // Start List View
  $(document).on('click', '.tvcmsproduct-grid-list .tvproduct-list', function () {
    removeClassesOfView();
    $('#products').addClass('list');
    $('.tvcmsproduct-grid-list .tvproduct-grid-2').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-list-2').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-catalog').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-grid').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-list').addClass('active');
  });
  // End List View
  // Start List-2 View
  $(document).on('click', '.tvcmsproduct-grid-list .tvproduct-list-2', function () {
    removeClassesOfView();
    $('#products').addClass('list-2');
    $('.tvcmsproduct-grid-list .tvproduct-grid-2').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-list').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-catalog').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-grid').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-list-2').addClass('active');
  });
  // End List-2 View
  // Start Catelog View
  $(document).on('click', '.tvcmsproduct-grid-list .tvproduct-catalog', function () {
    removeClassesOfView();
    $('#products').addClass('catelog');
    $('.tvcmsproduct-grid-list .tvproduct-grid').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-grid-2').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-list').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-list-2').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-catalog').addClass('active');
  });

});

function bottomTotop() {
  var startMenuStickyHeight = 250;
  var scrollHeight = $(document).scrollTop();
  if (scrollHeight > startMenuStickyHeight) {
    $('.tvbottom-to-top').fadeIn('slow');
  } else {
    $('.tvbottom-to-top').fadeOut('slow');
  }
}

function scrollToTop() {
  $('body,html').animate({
    scrollTop: 0 // Scroll to top of body
  }, 500);
}

$(document).on('click', '.tvbottom-to-top-icon , .tvsticky-up-arrow', function () { // When arrow is clicked
  scrollToTop();
});
